import { $qs, $qsa } from '../../../src/js/utils/QuerySelector';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

import Swiper, { Navigation, Autoplay, EffectFade, Pagination } from 'swiper';
// import Swiper and modules styles
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';	

gsap.registerPlugin(ScrollTrigger);



function horizontalNewsScroller() {
    const container = $qs('[data-target="scroll-container-news"]');
    const sections = $qsa('[data-target="scroll-section-news"] > div');
    
    const getMaxWidth = () => [...sections].reduce((val, section) => val + section.offsetWidth, 0);
    const maxWidth = getMaxWidth();
    const scrollSpeed = 2;

    //console.log(maxWidth);

    const timeline = gsap.timeline();

    timeline
    .to(sections, {
        x: () => window.innerWidth - maxWidth,
        ease: 'none',
    });

    ScrollTrigger.create({
        animation: timeline,
        trigger: container,
        pin: true,
        pinSpacing: true,
        scrub: 1,
        //   snap: {snapTo: directionalSnap(timeline), duration: 0.5},
        end: () => `+=${maxWidth / scrollSpeed}`,
        invalidateOnRefresh: true,
    });

    ScrollTrigger.sort();
}

function swiperNewsSliderMobile() {
    
    // init Swiper:
    var init = false;

    
        if ( ! init ) {
            init = true;

            const swiper = new Swiper('.swiper-news-slider-mobile', {

                modules: [Navigation, Autoplay, EffectFade, Pagination],
                loop: true,
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                },
                slidesPerView: 1,
                slidesPerGroup: 1,
                slidesPerColumn: 1,
                spaceBetween: 0,
                speed: 1000,
                breakpoints: {
                    // md
                    728: {
                        slidesPerView: 1,
                        slidesPerGroup: 1,
                        slidesPerColumn: 1,
                        spaceBetween: 60,
                    },
                },
            });
        }

}


function swiperNewsSlider() {    
    if( $qs('[data-target="scroll-container-news"]')) {
        if(window.innerWidth > 768) {
            window.addEventListener('load', () => {
                horizontalNewsScroller();
            });
        } else {
            swiperNewsSliderMobile();
        }
    }
}




export default swiperNewsSlider;